import React from 'react';
import { useTranslation } from 'react-i18next';
import Header from '../Common/Header';
import Footer from '../Common/Footer';
import Banner from '../Elements/Banner';

var bnrimg = require('../../images/banner/privacidad.jpg');

const asArray = (v) => (Array.isArray(v) ? v : []);

const PrivacyPolicy = () => {
    const { t } = useTranslation();
    const sections = asArray(t('pages.legal.declaracionPrivacidad.sections', { returnObjects: true }));
    return (
        <>
            <Header />
            <div className="page-content">
                <Banner title={t('pages.legal.declaracionPrivacidad.banner.title')} pagename={t('pages.legal.declaracionPrivacidad.banner.pagename')} description={t('pages.legal.declaracionPrivacidad.banner.description')} bgimage={bnrimg} />

                <div className="section-full p-t80 p-b50 mobile-page-padding">
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-lg-10 col-md-12">
                                <div className="service-single-block m-b30">
                                    <h3 className="m-b20">{t('pages.legal.declaracionPrivacidad.heading')}</h3>
                                    <p>{t('pages.legal.declaracionPrivacidad.intro')}</p>

                                    {sections.map((item, index) => (
                                        <React.Fragment key={index}>
                                            <h4>{item.heading}</h4>
                                            <p>{item.body}</p>
                                        </React.Fragment>
                                    ))}

                                    <h4>{t('pages.legal.declaracionPrivacidad.contact.heading')}</h4>
                                    <p>{t('pages.legal.declaracionPrivacidad.contact.intro')}</p>
                                    <p><strong>{t('pages.legal.declaracionPrivacidad.contact.emailLabel')}</strong> customer-service@soltarc.com</p>
                                    <p><strong>{t('pages.legal.declaracionPrivacidad.contact.addressLabel')}</strong> {t('pages.legal.declaracionPrivacidad.contact.addressValue')}</p>
                                    {/* <p><strong>{t('pages.legal.declaracionPrivacidad.contact.phoneLabel')}</strong> +52 55 442-467-3484</p> */}

                                    <p><strong>{t('pages.legal.declaracionPrivacidad.establishedLabel')}</strong> {t('pages.legal.declaracionPrivacidad.establishedValue')}</p>
                                    <p><strong>{t('pages.legal.declaracionPrivacidad.lastRevisedLabel')}</strong> {t('pages.legal.declaracionPrivacidad.lastRevisedValue')}</p>
                                    <p><strong>SoltArc Services</strong></p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    );
};

export default PrivacyPolicy;
